import { Box, Link, Typography } from "@mui/material";
import { TEXT } from "@/features/reassistRequests/utils/tokens";

/** R.E.ASSIST 利用規約のURL。 */
const REASSIST_TERMS_URL = "https://www.trustart.co.jp/reassist_terms";

/**
 * アーカイブ提供資料の購入条件。購入前の確認として、購入ボタンの近くに出す。
 * @returns 購入条件の表示
 */
export const SalePurchaseTerms: React.FC = () => (
  <Box
    component="section"
    aria-labelledby="sale-purchase-terms-title"
    sx={(theme) => ({
      border: `1px solid ${theme.palette.border.main}`,
      borderRadius: 1,
      px: 1.5,
      py: 1.5,
    })}
  >
    <Typography
      id="sale-purchase-terms-title"
      component="h3"
      sx={{ ...TEXT.meta, fontWeight: 700, mb: 0.5 }}
    >
      アーカイブ提供資料のご購入条件
    </Typography>
    <Box component="ul" sx={{ ...TEXT.meta, m: 0, pl: 2.5 }}>
      <li>
        本資料は、当社が過去に官公庁等から取得した資料の複製（個人情報等は黒塗り済み）で、取得時点の情報です。黒塗りにより閲覧できない部分があります。正確性・完全性・最新性・適法性、および第三者の権利を侵害しないことは保証しません。
      </li>
      <li>
        本資料（加工物を含む）は自己の事業のためにのみ利用でき、公開や第三者への再配布はできません。ただし、ご自身が当事者となる取引の相手方や媒介業者などに必要な範囲で提供する場合を除きます。
      </li>
      <li>黒塗りの解除・復元は禁止です。</li>
      <li>購入後の返金・キャンセルはできません。</li>
      <li>
        「同意して購入する」を押すと、
        <Link
          href={REASSIST_TERMS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          R.E.ASSIST利用規約
        </Link>
        および以上の条件に同意したものとなります。これらの条件は購入後も有効です。
      </li>
    </Box>
  </Box>
);
